<template>
  <div>
    <LayoutBanner
      activeNav="首页"
      :topColor="topColor"
      bannerType="header index"
      :height="250"
    />
    <div class="container">
      <!-- 艺讯 -->
      <section class="art_info">
        <div class="repeatTitle">
          <div class="title_text art_info_line">
            <h1>艺讯</h1>
            <h2>Literary Information</h2>
          </div>
        </div>

        <div class="top">
          <div @click="newsDetail(coverNews[0].id)">
            <img :src="coverNews[0].img_cover_full" alt="" />
            <p>
              <i></i>
              {{ coverNews[0].name }}
              <!-- {{ coverNews[coverNews_active].desc }} -->
            </p>
          </div>
          <ul>
            <li
              v-for="(coverNews_item, coverNews_index) in normalNews.slice(0,3)"
              :key="coverNews_index"
              :class="
                coverNews_active === coverNews_index
                  ? 'art_info_item active'
                  : 'art_info_item'
              "
              @mouseenter="changeCoverNews(coverNews_index)"
              @click="newsDetail(coverNews_item.id)"
            >
              <div>
                <h1>
                  <!-- <i></i> -->
                  {{ coverNews_item.name }}
                </h1>
                <span>{{ coverNews_item.cd }}</span>
              </div>
              <p>
                {{ coverNews_item.desc }}
              </p>
            </li>
          </ul>
        </div>

        <div class="other-newslist">
          <div class="item" @click="newsDetail(item.id)" v-for="(item,index) in normalNews.slice(3,7)" :key="index">
            <div class="left">{{ item.name }}</div>
            <div class="right">{{ item.cd }}</div>
          </div>
        </div>

        <!-- <ul class="bottom">
          <li
            v-for="(normalNews_item, normalNews_index) in normalNews"
            :key="normalNews_index"
            @click="newsDetail(normalNews_item.id)"
          >
            <img :src="normalNews_item.img_cover_full" alt="" />
            <div>{{ normalNews_item.name }}&gt;&gt;</div>
          </li>
          <li>
            <img
              @click="toArtInfo"
              src="../../assets/images/index/ZX-button--more@2x.png"
              alt=""
            />
          </li>
        </ul> -->
      </section>
      <!-- 文艺评奖 -->
      <section class="art_awards">
        <div class="repeatTitle">
          <div class="title_text">
            <h1>文艺评奖</h1>
            <h2>Literary Information</h2>
          </div>
        </div>

        <div class="top">
          <!-- <span>进入评审评奖平台&gt;&gt;</span> -->
        </div>

        <div v-for="(match,index) in latestMatch" :key="index"  class="middle">
          <div style="width:calc(100% - 200px);">
            <!-- <img
              v-if="latestMatch.img_logo_full"
              :src="latestMatch.img_logo_full"
              alt=""
            />
            <img
              v-else-if="latestMatch.oc_logo_full"
              :src="latestMatch.oc_logo_full"
              alt=""
            />
            <img
              v-else
              src="../../assets/images/index/icon-PJ-Trophy@2x.png"
              alt=""
            /> -->
            <div style="width:calc(100% - 50px);">
              <h1>
                <span style="display: inline-block;max-width: calc(100% - 100px);white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ match.name }}</span>
                <span class="red" @click="workDetail(match)"
                  >进入&gt;&gt;</span
                >
              </h1>
              <p>
                {{ match.synopsis }}
              </p>
            </div>
          </div>
          <img v-if="match.img_main_full" :src="match.img_main_full" alt="" />
          <img
            style="width:140px;margrin-left:60px;"
            v-else
            src="../../assets/images/SY-JB-moren.png"
            alt=""
          />
        </div>

        <div class="bottom" v-if="latestMatch.is_vote==1">
          <div class="sendAwards">
            <span class="toSendAwards" @click="workDetail(latestMatch)">去投票</span>
            <h1>我要投票</h1>
            <p>
              {{ latestMatch.join_msg }}
            </p>
            <ul>
              <li v-for="(work_item, work_index) in workList" :key="work_index">
                <img
				  @click="opusDetail(work_item)"
                  style="width: 160px; height: 120px;cursor: pointer;"
                  :src="work_item.img_full"
                  alt=""
                />
                <div class="other" style="margin-top:15px;">
                  <div style="font-size:12px;">{{ work_item.id }}号作品</div>
                  <div style="font-size:12px;">《{{ work_item.title }}》</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- 专家库 -->
      <section class="experts">
        <div class="repeatTitle">
          <div class="title_text">
            <h1>专家库</h1>
            <h2>Literary Information</h2>
          </div>
        </div>

        <div class="top">
          <div class="btns">
            <img
              @click="toUpload"
              src="../../assets/images/index/index-button-ZJ_01@2x.png"
              alt=""
            />
            <img
              @click="select"
              src="../../assets/images/index/index-button-ZJ_02@2x.png"
              alt=""
            />
          </div>
        </div>

        <div class="bottom">
          <img src="../../assets/images/index/index-ZJ-bt-pre.png" alt=""  @click="changePage('left')"/>
          <ul>
            <li
              v-for="(expert_item, expert_index) in expertsList"
              :key="expert_index"
            >
              <img
                v-if="expert_item.img_avatar_full"
                :src="expert_item.img_avatar_full"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/user/yh-icon-touxiang@2x.png"
                alt=""
              />
              <div>
                <h1>{{ expert_item.name }}</h1>
              </div>
              <p>
                {{ expert_item.synopsis }}
              </p>
              <div><span @click="expertDetail(expert_item.id)">详情&gt;&gt;</span></div>
            </li>
          </ul>
          <img src="../../assets/images/index/index-ZJ-bt-nex.png" alt=""  @click="changePage('right')"/>
        </div>
      </section>
      <!-- 数字艺术馆 -->
      <section class="art_digitization">
        <div class="repeatTitle">
          <div class="title_text">
            <h1 style="color: white">数字艺术馆</h1>
            <h2>Literary Information</h2>
          </div>
        </div>

        <div class="skip">
         <!-- <i></i>
          <h1 @click="numCity">进入数字艺术馆平台<span>&gt;&gt;</span></h1> -->
        </div>

        <div class="classSkip">
          <div @click="toArt" class="left">
            <div class="title">
              <h1>美术馆</h1>
              <h2>Art gallery</h2>
            </div>
          </div>
          <div class="middle">
            <div @click="toPhoto" class="photo">
              <div class="title">
                <h1>摄影馆</h1>
                <h2>Photography gallery</h2>
              </div>
            </div>
            <div @click="toStage" class="stage">
              <div class="title">
                <h1>舞台艺术馆</h1>
                <h2>Stage art gallery</h2>
              </div>
            </div>
            <div @click="toHall" class="hall">
              <div class="title">
                <h1>书法馆</h1>
                <h2>Calligraphy hall</h2>
              </div>
            </div>
          </div>
          <div @click="toComprehensive" class="right">
            <div class="title">
              <h1>综合馆</h1>
              <h2>Comprehensive Pavilion</h2>
            </div>
          </div>
        </div>
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import NewsServices from "../../xx-vue/services/news";
import MatchServices from "../../xx-vue/services/match";
import WorksServices from "../../xx-vue/services/works";
import expertsServices from "../../xx-vue/services/expert";
import Storage from "../../xx-vue/utils/storage";
export default {
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      coverNews: [
        {
          img_cover_full: "",
          name: "",
        },
      ], //封面新闻
      normalNews: [], //普通新闻
      coverNews_active: 0, //当前激活的封面新闻
      latestMatch: {}, //最新赛事
      workList: [], //作品列表
      expertsList: [], //专家列表
      page: 1,
      total: 10
    };
  },
  mounted() {
    this.initScroll();
    this.initData();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      this.userInfo = userInfo;
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //初始化页面数据
    async initData() {
      //获取封面新闻
      const coverNews = await NewsServices.getNewsAsync({
        page: 1,
        limit: 3,
        type: 1,
      });
      this.coverNews = coverNews.data.list;
      this.coverNews = this.coverNews.map((v) => {
        return { ...v, cd: v.cd.split(" ")[0] };
      });
      //获取普通新闻
      const normalNews = await NewsServices.getNewsAsync({
        page: 1,
        limit: 7,
        type: 0,
      });
      this.normalNews = (normalNews.data.list||[]).map((v) => {
        return { ...v, cd: v.cd.split(" ")[0] };
      });;
      //获取最新赛事
      const latestMatch = await MatchServices.getMatchAsync({
        page: 1,
        limit: 3,
      });
      this.latestMatch = {...(latestMatch.data.list||{})};
      //获取作品列表
      const workList = await WorksServices.getWorksAsync({
        page: 1,
        limit: 5,
		project_id: this.latestMatch.id
      });
      this.workList = workList.data.list.slice(0, 5);
      console.log(this.workList);
      //获取专家列表
      const expertsList = await expertsServices.getExpertsAsync({
        page: 1,
        limit: 3,
      });
      this.expertsList = expertsList.data.list;
      this.total = expertsList.data.total
      console.log(this.expertsList);
    },
    //切换封面新闻
    changeCoverNews(index) {
      this.coverNews_active = index;
    },
    //跳转新闻详情
    newsDetail(id) {
      this.$router.push(`/art_info/detail?id=${id}`);
    },
	//跳转专家详情
	expertDetail(id){
		this.$router.push(
			`/user/visit?expert_id=${id}`
		);
	},
    //跳转赛事详情
    workDetail(item) {
      this.$router.push(
        `/match/match_works?id=${item.id}&project_id=${item.project_id}&group_id=${item.group_id}`
      );
    },
    //跳转艺讯
    toArtInfo() {
      this.$router.push("/art_info");
    },
    // //跳转作品
    // toWorks(item) {
    //   this.$router.push("/match/match_works");
    // },
    //上传资料
    toUpload() {
      if (this.userInfo) {
        this.$router.push("/expert/expert_upload");
      } else {
        this.$message.error("请登录");
        this.$router.push("/login");
      }
    },
    //抽选专家
    select() {
      this.$router.push("/expert/select_expert");
    },
    //跳转美术馆
    toArt() {
      window.open(
        "http://sz.scwyy.cn/home/html/arts.html?type_1=1&type_id=1",
        "_blank"
      );
    },
	//跳转作品详情
	opusDetail(item){
		this.$router.push(
			`/match/Work_detail?id=${item.id}&project_id=${item.project_id}&group_id=${item.group_id}`
		)
	},
    //跳转摄影馆
    toPhoto() {
      window.open(
        "http://sz.scwyy.cn/home/html/arts.html?type_1=1&type_id=3",
        "_blank"
      );
    },
    //跳转舞台艺术
    toStage() {
       window.open(
        "http://sz.scwyy.cn/home/html/arts.html?type_1=4&type_id=4",
        "_blank"
      );
    },
    //跳转书法馆
    toHall() {
      window.open(
        "http://sz.scwyy.cn/home/html/arts.html?type_1=2&type_id=2",
        "_blank"
      );
    },
    //跳转综合管馆
    toComprehensive() {
       window.open(
        "http://sz.scwyy.cn/home/html/arts.html?type_1=5&type_id=5",
        "_blank"
      );
    },
	//跳转艺术馆首页
	numCity(){
		window.open(
		  "http://sz.scwyy.cn/home",
		  "_blank"
		);
	},
  //分页查询专家
  changePage(type){
      switch (type) {
        case "left":
          if (this.page !== 1) {
            this.getExpert(this.page - 1)
          }
          break;
        case "right":
          if (this.page !== this.total) {
              this.getExpert(this.page + 1)     
          }
          break;
      }
  },
  getExpert(page){
     expertsServices.getExpertsAsync({
            page: page,
            limit: 3,
          }).then((response) => {
             this.expertsList = response.data.list;
            this.total = Math.ceil(response.data.total / 3)
            this.page = page
          })
  }
  },
};
</script>

<style lang="less" scoped>

.other-newslist{
  margin: 10px 0px;
  font-size: 0px;
  .item{
    display: inline-block;
    vertical-align: middle;
    width: calc(50% - 20px);
    padding: 10px 5px;

    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    &:hover{
      background-color: #f5f5f5;
    }

    &:nth-child(2n){
      margin-left: 20px;
    }
    &:nth-child(2n-1){
      margin-right: 20px;
    }

    .left,.right{
      display: inline-block;
      vertical-align: middle;
    }

    .left{
      width:calc(100% - 100px - 10px);margin-right:10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      font-weight: 700;
    }
    .right{
      width:100px;
      color:#b5b3b3;
      font-size: 13px;
    }
  }
}

.container {
  width: 100%;

  .repeatTitle {
    display: flex;
    justify-content: center;

    .title_text {
      text-align: center;
      background: url("../../assets/images/index/title-line1@2x.png") no-repeat
        54px 0px;
      background-size: contain;
      padding: 10px;
    }

    .art_info_line {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2left@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        left: -470px;
        top: 26px;
      }

      &::before {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2right@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        right: -470px;
        top: 26px;
      }
    }

    h1 {
      font-size: 26px;
      padding-top: 6px;
    }

    h2 {
      font-size: 14px;
      color: #989898;
      font-weight: normal;
    }
  }

  .art_info {
    padding: 48px 0;
    width: 1200px;
    margin: 0 auto;

    .top {
      margin-top: 48px;
      display: flex;

      & > div {
        width: 600px;
        height:calc(9/16*600px);
        position: relative;
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          cursor: pointer;
        }

        p {
          position: absolute;
          bottom: 0;
          color: white;
          padding: 20px;
          padding-right: 30px;

          i {
            display: block;
            width: 18px;
            height: 6px;
            background-color: #f2252f;
            position: relative;
            top: -12px;
          }
        }
      }

      & > ul {
        width: calc(100% - 600px - 25px);margin-left:25px;

        .art_info_item {
          // padding: 29px 32px;
          height: calc( 100%/3 );
          padding: 11px 15px 11px 0px;
          cursor: pointer;
          border-bottom: 1px dashed #c3c2c2;

          & > div {
            margin-bottom: 16px;
            display: flex;
            justify-content: space-between;

            & > h1 {
              font-size: 16px;
              position: relative;
              // text-indent: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 120px);

              & > i {
                display: block;
                width: 8px;
                height: 14px;
                background: url("../../assets/images/index/icon-ZX-triangle1-default@2x.png")
                  no-repeat;
                background-size: contain;
                position: absolute;
                top: 6px;
              }
            }

            & > span {
              font-size: 14px;
              color: #989898;
            }
          }

          & > p {
            // font-size: 14px;
            font-size: 13px;
            // padding-left: 20px;
            padding-right: 28px;
            color: #656565;
            color:#949494;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          // background-color: #f3f4f6;
        }

        .art_info_item.active {
          background-color: white;
          position: relative;

          & > div {
            & > h1 {
              & > i {
                display: block;
                width: 8px;
                height: 14px;
                background: url("../../assets/images/index/icon-ZX-triangle2@2x.png")
                  no-repeat;
                background-size: contain;
                position: absolute;
                top: 6px;
              }
            }
          }

          &::after {
            content: "";
            display: block;
            width: 4px;
            height: 100%;
            position: absolute;
            background-color: red;
            right: 0;
            top: 0;
          }
        }
      }
    }

    .bottom {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      & > :not(:last-child) {
        width: 18%;
      }

      & > :last-child {
        width: 5%;
      }

      li {
        position: relative;
        cursor: pointer;
        img {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        div {
          position: relative;
          padding: 10px;
          margin-top: 130px;
          background-color: rgba(11, 15, 24, 0.3);
          color: white;
          font-size: 14px;
          cursor: pointer;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
  }

  .art_awards {
    padding: 48px 0;
    background: url("../../assets/images/index/index-PJ-bg@2x.png") no-repeat;
    background-size: 100% 100%;

    .top {
      width: 1200px;
      margin: 0 auto;
      border-bottom: 3px solid #d1d1d1;
      display: flex;
      justify-content: flex-end;
      color: #f2252f;
      padding-bottom: 10px;
      font-weight: bold;

      span {
        cursor: pointer;
      }
    }

    .middle {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 22px;
      margin-bottom: 32px;

      & > div {
        width: 60%;
        display: flex;
        align-items: center;

        & > img {
          width: 150px;
          height: 150px;
          margin-right: 40px;
        }

        & > div {
          & > h1 {
            font-size: 24px;
            font-weight: normal;
            margin-bottom: 20px;
            span{
              display: inline-block;
              vertical-align: middle;
            }
            & > span.red {
              font-size: 14px;
              color: #f2252f;
              margin-left: 16px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }

      & > img {
        width: 200px;
        height: 140px;
      }
    }

    .bottom {
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      background: url("../../assets/images/index/index-TP-bg.png") no-repeat;
      background-size: 100% 100%;
      color: white;
      padding: 60px 180px;

      .sendAwards {
        position: relative;
        text-align: center;

        h1 {
          margin-bottom: 25px;
          font-size: 20px;
        }

        ul {
          margin-top: 34px;
          display: flex;
          // justify-content: space-between;
          justify-content: left;

          li {
            width: 18%;
            margin-right:30px;

            img {
              width: 100%;
            }
          }
        }

        .toSendAwards {
          display: inline-block;
          padding: 9px 20px;
          background: url("../../assets/images/index/button-88_36@2x.png")
            no-repeat;
          background-size: contain;
          font-size: 14px;
          cursor: pointer;
          user-select: none;
          position: absolute;
          right: 0;
        }
      }
    }
  }

  .experts {
    padding: 48px 0;
    width: 1200px;
    margin: 0 auto;

    .top {
      margin-top: 28px;
      margin-bottom: 52px;

      .btns {
        display: flex;
        margin: 0 auto;
        width: 400px;

        img {
          width: 50%;
          height: 64px;
          cursor: pointer;
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > i {
        width: 36px;
        height: 65px;
      }

      & > ul {
        display: flex;
        justify-content: center;

        & > :not(:last-child) {
          margin-right: 8%;
        }

        & > li {
          width: 27%;
          background: url("../../assets/images/index/index-ZJ-bg wireframe@2x.png")
            no-repeat;
          background-size: 100% 100%;
          padding: 28px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;

          & > img {
            width: 160px;
            height: 160px;
            border-radius: 50%;
            margin-bottom: 22px;
          }

          & > div {
            width: 100%;

            h1 {
              margin: 0 auto;
              color: #af1921;
              padding: 7px 26px;
              font-size: 20px;
              background: url("../../assets/images/index/index-ZJ-name@2x.png")
                no-repeat;
              background-size: 100% 100%;
              margin-bottom: 26px;
            }
          }

          & > p {
            color: #656565;
            margin-bottom: 20px;

            display: -webkit-box;    
            -webkit-box-orient: vertical;    
            -webkit-line-clamp: 3;    
            overflow: hidden;
          }

          & > div {
            display: flex;
            justify-content: flex-end;

            span {
              color: #e54048;
              cursor: pointer;
            }
          }
        }
      }

      & > :first-child {
        width: 36px;
        height: 65px;
        margin-right: 56px;
        cursor: pointer;
      }

      & > :last-child {
        width: 36px;
        height: 65px;
        margin-left: 56px;
        cursor: pointer;
      }
    }
  }

  .art_digitization {
    padding: 48px 0;
    background: url("../../assets/images/index/index-SZYSG-bg@2x.png") no-repeat;
    background-size: 100% 100%;

    .skip {
      display: flex;
      justify-content: center;
      margin-top: 46px;
      align-items: center;
      margin-bottom: 56px;

      i {
        display: block;
        margin-right: 12px;
        width: 8px;
        height: 40px;
        background: url("../../assets/images/index/icon-ZX-line@2x.png");
      }

      h1 {
        font-size: 16px;
        cursor: pointer;

        span {
          margin-left: 16px;
        }

        &:hover {
          color: #e54048;
        }
      }

      color: white;
    }

    .classSkip {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      & > div {
        height: 520px;
      }

      .left {
        width: 26%;
        background: url("../../assets/images/index/index-SZ-art@2x.png")
          no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .middle {
        width: 46%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .photo {
          width: 49%;
          background: url("../../assets/images/index/index-SZ-photo@2x.png")
            no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .stage {
          width: 49%;
          background: url("../../assets/images/index/index-SZ-stage@2x.png")
            no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .hall {
          margin-top: 2%;
          width: 100%;
          background: url("../../assets/images/index/index-SZ-calli@2x.png")
            no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .right {
        width: 26%;
        background: url("../../assets/images/index/index-SZ-com@2x.png")
          no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .title {
        color: white;
        text-align: center;
        background: url("../../assets/images/index/index-SZ-word-bg@2x.png")
          no-repeat;
        background-size: 100% 100%;
        padding: 16px 40px;

        h1 {
          font-size: 18px;
          font-weight: normal;
          margin-bottom: 10px;
        }

        h2 {
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>